module.exports = __webpack_public_path__ + "img/ic_juheshujudaping.612f2609.svg";